import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { Home } from './pages/home';
import './App.css';
import Login from './pages/adminpage/login';
import { Header } from './pages/homepage/header';
import { Kapcsolat } from './pages/kapcsolat/kapcsolat';
import { TravelDetail } from '../src/components/travel_detail';
import { RegistrationForm } from './components/registration_form';
import { Naptar_Page } from './pages/naptar/naptar_page';
import { Travel_Upload } from './admin_u/travel_upload';
import TravelEdit from './admin_u/travel_edit';
import { AdminTravelList } from './admin_u/admin_page';
import { SliderAdmin } from './admin_u/slider_admin';
import MiertVelunk from './components/miert_velunk';
import LegalImpressum from './components/LegalImpressum';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';
import ThankYouPage from './components/thankyou';
import { useDispatch } from 'react-redux';
import { setPermission } from '../src/store/store';
// Analytics import
import { initGA, logPageView } from './analytics/analytics';

function App() {
  const dispatch = useDispatch();
  const url = process.env.REACT_APP_API_URL;
  
  useEffect(() => {
    fetch(url + "/api/me", {
      credentials: 'include'
    })
      .then(async (res) => {
        if (!res.ok) return null;
        const isJson = res.headers.get('content-type')?.includes('application/json');
        if (!isJson) return null;
        return res.json();
      })
      .then((data) => {
        if (data?.user) {
          dispatch(setPermission({ isAdmin: true }));
        }
      })
      .catch((err) => {
        console.error('ME endpoint hiba:', err);
      });
  }, []);
  

  useEffect(() => {
    initGA(); // Google Analytics inicializálása
  }, []);

  return (
    <Router>
      <Main />
    </Router>
  );
}

function Main() {
  const location = useLocation();

  // PageView loggolása route váltáskor
  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);

  return (
    <div>
      {location.pathname !== '/' && (
        <Header />
      )}

      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<AdminTravelList />} />
        <Route path="/kapcsolat" element={<Kapcsolat />} />
        <Route path="/travel/:id" element={<TravelDetail />} />
        <Route path="/apply/:id" element={<RegistrationForm />} />
        <Route path="/naptar" element={<Naptar_Page />} />
        <Route path="/travel_upload" element={<Travel_Upload />} />
        <Route path="/travel_edit/:id" element={<TravelEdit />} />
        <Route path="/admin/slider" element={<SliderAdmin />} />
        <Route path="/rolunk" element={<MiertVelunk />} />
        <Route path="/aszf" element={<TermsOfService />} />
        <Route path="/jogi_nyilatkozat" element={<LegalImpressum />} />
        <Route path="/adatvedelmi_nyilatkozat" element={<PrivacyPolicy />} />
        <Route path="/koszonjuk" element={<ThankYouPage />} />
      </Routes>
    </div>
  );
}

export default App;
